var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135.46666mm",
    height: "135.46667mm",
    viewBox: "0 0 135.46666 135.46667",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(795.85005,-110.88288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(0.26458333,0,0,0.26458333,-795.85005,110.88288)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e6e5e5"
    },
    cx: 256,
    cy: 256,
    r: 256,
    id: "circle1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaaaaa",
      fillOpacity: 1
    },
    d: "M 459.96,398.712 V 122.76 c 0,-6.6 -5.4,-12 -12,-12 H 64.112 c -6.6,0 -12,5.4 -12,12 v 275.952 c 0.008,0 408.856,0 407.848,0 z",
    id: "path1-61"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.112,
    y: 125.76,
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    },
    width: 377.84,
    height: 257.92001,
    id: "rect1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 398.71201,
    style: {
      fill: "#d8d8d8"
    },
    width: 479.92001,
    height: 7.5040002,
    id: "rect2"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#aaaaaa"
    },
    points: "496,406.216 472.008,421.208 40.08,421.208 16.08,406.216 ",
    id: "polygon2"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    },
    id: "g2-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 296.304,398.712 h -80.688 c 0.768,4.208 4.52,7.504 9.216,7.504 h 62.248 c 4.704,0 8.464,-3.296 9.224,-7.504 z",
    id: "path2-79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e6e5e5"
    },
    cx: 167.888,
    cy: 144,
    r: 8,
    id: "circle2"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e6e5e5"
    },
    cx: 135.888,
    cy: 144,
    r: 8,
    id: "circle3"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e6e5e5"
    },
    cx: 103.888,
    cy: 144,
    r: 8,
    id: "circle4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.87199,
    y: 140.01601,
    style: {
      fill: "#e6e5e5"
    },
    width: 224,
    height: 8,
    id: "rect4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.87201,
    y: 320,
    style: {
      fill: "#e6e5e5"
    },
    width: 32,
    height: 8,
    id: "rect5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.672,
    y: 320,
    style: {
      fill: "#e6e5e5"
    },
    width: 32,
    height: 8,
    id: "rect6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.44,
    y: 320,
    style: {
      fill: "#e6e5e5"
    },
    width: 32,
    height: 8,
    id: "rect7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.272,
    y: 320,
    style: {
      fill: "#e6e5e5"
    },
    width: 32,
    height: 8,
    id: "rect8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.07201,
    y: 320,
    style: {
      fill: "#e6e5e5"
    },
    width: 32,
    height: 8,
    id: "rect9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.872,
    y: 320,
    style: {
      fill: "#e6e5e5"
    },
    width: 32,
    height: 8,
    id: "rect10"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111.88,
    y: 352,
    style: {
      fill: "#a94064",
      fillOpacity: 1
    },
    width: 287.992,
    height: 8,
    id: "rect11"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#e6e5e5"
    },
    points: "337.8,212.12 280.08,270.352 224.712,214.496 171.232,267.976 166.52,263.264 224.728,205.056 280.08,260.888 333.072,207.432 ",
    id: "polygon11"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8ad5dd"
    },
    cx: 168.88,
    cy: 265.60001,
    r: 19.488001,
    id: "circle11"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 168.88,
    cy: 265.60001,
    r: 8.5760002,
    id: "circle12"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8ad5dd"
    },
    cx: 280.95999,
    cy: 265.60001,
    r: 19.488001,
    id: "circle13"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 280.95999,
    cy: 265.60001,
    r: 8.5760002,
    id: "circle14"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a94064",
      fillOpacity: 1
    },
    cx: 224.72,
    cy: 209.75999,
    r: 27.176001,
    id: "circle15"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 224.72,
    cy: 209.75999,
    r: 11.96,
    id: "circle16"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a94064",
      fillOpacity: 1
    },
    cx: 335.44,
    cy: 209.75999,
    r: 27.176001,
    id: "circle17"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 335.44,
    cy: 209.75999,
    r: 11.96,
    id: "circle18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.825995407e95e03169b2c3f6765e1f25.svg";
export { ForwardRef as ReactComponent };